import {
  IonCard,
  IonGrid,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
} from "@ionic/react";
import {
  Chart,
  ArcElement,
  Tooltip,
  Legend,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  CategoryScale,
} from "chart.js";
import {
  collection,
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import { Doughnut, Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../firebaseConfig";
import { setTimeSeriesStoreData } from "../redux/actions";
import "chartjs-adapter-moment";

const TimeSeriesGraph = (props: any) => {
  Chart.register(
    ArcElement,
    TimeScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    CategoryScale
  );
  const [dataFetchComplete, setDataFetchComplete] = useState(false);
  const [timeSeriesData, setTimeSeriesData] = useState<any>([]);
  const [timeStampValue, setTimeStampValue] = useState<any>([]);
  const [packVoltageValue, setpackVoltageValue] = useState<any>([]);
  const [packCurrentValue, setPackCurrentValue] = useState<any>([]);
  const [tempValue, setTempValue] = useState<any>([]);
  const timeSeriesDataReduxStore = useSelector(
    (state: any) => state.timeSeriesData
  );
  const mountedRef = useRef(true);
  const dispatch = useDispatch();
  const fetchTimeSeriesData = async (mac: string) => {
    try {
      console.log("mac: " + mac);
      let querySnapshot = await getDocs(
        query(
          collection(db, "teltonikaConnector/" + mac + "/telemetry/"),
          orderBy("timeStamp", "desc"),
          limit(5)
        )
      );
      let result: any = [];
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ": ts => ", JSON.stringify(doc.data()));
        result.push(doc.data());
        setTimeSeriesData([...timeSeriesData, ...result]);
        dispatch(setTimeSeriesStoreData(result));
      });
    } catch (error) {
      console.log("Unknown error while fetchDataFireStore: " + error);
    }
  };
  useEffect(() => {
    // console.log("mac: " + props.mac);
    let packVoltages = [];
    let packCurrents = [];
    let timeStamps = [];
    let temps = [];
    console.log("timeSeriesDataReduxStore: " + timeSeriesDataReduxStore);
    if (!timeSeriesDataReduxStore) {
      fetchTimeSeriesData(props.mac);
    }
    packVoltages = timeSeriesDataReduxStore?.map(
      (item: any) => item["packVoltage"]
    );
    setpackVoltageValue(packVoltages?.reverse());
    timeStamps = timeSeriesDataReduxStore?.map((item: any) =>
      new Date(item["timeStamp"])
        .toTimeString()
        .replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")
    );
    setTimeStampValue(timeStamps?.reverse());
    packCurrents = timeSeriesDataReduxStore?.map(
      (item: any) => item["packCurrent"] / 1000
    );
    setPackCurrentValue(packCurrents?.reverse());
    temps = timeSeriesDataReduxStore?.map(
      (item: any) =>
        (item["temp1"] +
          item["temp2"] +
          item["temp3"] +
          item["temp4"] +
          item["temp5"] +
          item["temp6"] +
          item["temp7"] +
          item["temp8"]) /
        8
    );
    setTempValue(temps?.reverse());
    console.log("timeStampValue: " + JSON.stringify(timeStampValue));
    return () => {
      mountedRef.current = false;
    };
  }, [timeSeriesDataReduxStore]);

  const data = {
    labels: timeStampValue,
    datasets: [
      {
        label: "Pack Voltage (V)",
        data: packVoltageValue,
        fill: true,
        backgroundColor: "light",
        borderColor: "rgba(75,192,192,1)",
      },
      {
        label: "Pack Current (A)",
        data: packCurrentValue,
        fill: false,
        borderColor: "#742774",
      },
      {
        label: "Pack Temperature (Avg)",
        data: tempValue,
        fill: false,
        borderColor: "#f58423",
      },
    ],
  };

  return (
    <IonGrid style={{ height: "300px" }}>
      <Line
        data={data}
        options={{
          maintainAspectRatio: false,
          responsive: true,
        }}
      />
    </IonGrid>
  );
};

export default TimeSeriesGraph;
